<template>
	<template v-if="permissionModule.canSeeNote(note)">
		<div
			:class="
				props.isNormalView
					? 'col-md-6 col-sm-12'
					: '' & readMore
						? 'read-more'
						: null
			"
		>
			<div class="card note-card">
				<div class="note-section">
					<div class="note-header pb-1">
						<h4 class="card-title">
							<a
								v-if="note.student"
								@click="studentURL(note.student.student_id)"
								href="#"
							>
								{{ note?.student?.fname }}
								{{ note?.student?.lname }}
							</a>
						</h4>
						<div
							v-if="
								!readMore &&
								!isExport &&
								props.store?.user?.userType !== 'student'
							"
							class="d-flex align-center"
							style="column-gap: 1rem"
						>
							<a
								><font-awesome-icon
									@click="
										$emit('openLogModal', note.journal_id)
									"
									icon="fa-regular fa-clock-rotate-left"
									class="d-flex"
									width="1.5rem"
									color="var(--clr-orange)"
									v-tooltip="'Historik'"
							/></a>
							<a
								v-if="
									permissionModule.hasPermission(
										'is_employee_can_export_journal_as_pdf',
									)
								"
								><font-awesome-icon
									@click="exportSingle(note.journal_id)"
									icon="fa-regular fa-download"
									class="d-flex"
									width="1.5rem"
									color="#00acee"
									v-tooltip="'Eksporter notat'"
							/></a>
							<a
								v-if="
									permissionModule.hasPermission(
										'is_comment_journal',
									) && note.student.user_status !== 'archive'
								"
								><font-awesome-icon
									@click="
										$emit('addComment', note.journal_id)
									"
									icon="fa-regular fa-message-plus"
									class="d-flex"
									width="1.5rem"
									color="var(--clr-purple)"
									v-tooltip="'Kommenter'"
							/></a>
							<a
								v-if="
									(permissionModule.hasPermission(
										'is_update_journal',
									) &&
										note.student.user_status !==
											'archive') ||
									(note.add_user_name ===
										`${currentUser.fname} ${currentUser.lname}` &&
										Date.now() / 1000 - note.add_date <=
											7200 &&
										note.student.user_status !== 'archive') // 7200 is 2 hours in unix time
								"
								><font-awesome-icon
									@click="$emit('openModal', note.journal_id)"
									icon="fa-regular fa-pen-to-square"
									class="d-flex"
									width="1.5rem"
									color="var(--clr-green)"
									v-tooltip="'Rediger'"
							/></a>
							<a
								v-if="
									permissionModule.hasPermission(
										'is_delete_journal',
									) && note.student.user_status !== 'archive'
								"
								><font-awesome-icon
									@click="deleteNote(note.journal_id)"
									icon="fa-regular fa-trash-can"
									class="d-flex"
									width="1.5rem"
									color="var(--clr-red)"
									v-tooltip="'Slet'"
							/></a>
						</div>
					</div>
					<div class="row separator" />
					<div
						class="note-body-wrapper"
						:style="
							!isNormalView || isExport
								? 'height: fit-content'
								: ''
						"
					>
						<div
							class="note-body black"
							ref="noteBodyRefs"
							style="overflow: hidden"
						>
							<template
								v-if="
									note.categories &&
									note.headline_id &&
									note.headline_type !== 'plan'
								"
							>
								<div class="row">
									<div
										class="note-headline"
										:class="
											isNormalView ? 'col-4' : 'col-2'
										"
									>
										Overskrift:
									</div>
									<div
										:class="
											isNormalView ? 'col-8' : 'col-10'
										"
									>
										{{ note.categories.cat_name }}
									</div>
								</div>
								<br />
							</template>
							<template
								v-if="
									note.categories?.sub_categories &&
									note.headline_type !== 'plan'
								"
							>
							</template>
							<template
								v-if="
									note.headline_id &&
									note.headline_type === 'plan'
								"
							>
								<div class="row">
									<div
										class="note-headline"
										:class="
											isNormalView ? 'col-4' : 'col-2'
										"
									>
										Plan:
									</div>
									<div
										:class="
											isNormalView ? 'col-8' : 'col-10'
										"
									>
										{{ note.plan_title }}
									</div>
								</div>
								<br />
							</template>
							<template v-if="note?.department?.dep_name">
								<div class="row">
									<div
										class="note-headline"
										:class="
											isNormalView ? 'col-4' : 'col-2'
										"
									>
										{{ terms.department.single_cap }}:
									</div>
									<div
										:class="
											isNormalView ? 'col-8' : 'col-10'
										"
									>
										{{ note.department.dep_name }}
									</div>
								</div>
								<br />
							</template>
							<template
								v-if="
									note.categories?.sub_categories &&
									note.headline_type !== 'plan'
								"
							>
								<div
									class="row"
									style="row-gap: 1rem; line-height: normal"
								>
									<template
										v-for="subCategory in note.categories
											.sub_categories"
										:key="subCategory.templates_id"
									>
										<template
											v-if="
												note?.answers.find(
													(answer) =>
														answer.template_id ===
														subCategory.templates_id,
												)?.value
											"
										>
											<div
												:class="
													isNormalView
														? 'col-4'
														: 'col-2'
												"
												class="category-headline"
											>
												{{ subCategory.headlinetext }}:
											</div>
											<div
												:class="
													isNormalView
														? 'col-8'
														: 'col-10'
												"
												class="category-answer"
												:style="
													isNormalView
														? {
																display:
																	'-webkit-box',
																'-webkit-box-orient':
																	'vertical',
																'-webkit-line-clamp':
																	note
																		.categories
																		.sub_categories
																		.length >
																	1
																		? 3
																		: 8,
																overflow:
																	'hidden',
																whiteSpace:
																	'pre-wrap',
															}
														: {
																whiteSpace:
																	'pre-wrap',
															}
												"
											>
												<Highlighter
													class="my-highlight"
													highlightClassName="highlight"
													:searchWords="keywords"
													:autoEscape="true"
													:textToHighlight="
														note?.answers.find(
															(answer) =>
																answer.template_id ===
																subCategory.templates_id,
														)?.value
													"
												>
												</Highlighter>
											</div>
										</template>
									</template>
								</div>
							</template>
							<template v-if="note.information">
								<div class="row">
									<div
										class="note-headline"
										:class="
											isNormalView ? 'col-4' : 'col-2'
										"
									>
										Notat:
									</div>
									<div
										:class="
											isNormalView ? 'col-8' : 'col-10'
										"
									>
										<Highlighter
											class="my-highlight note-information"
											highlightClassName="highlight"
											:searchWords="keywords"
											:autoEscape="true"
											:style="
												isNormalView
													? {
															display:
																'-webkit-box',
															'-webkit-box-orient':
																'vertical',
															'-webkit-line-clamp': 10,
															overflow: 'hidden',
															whiteSpace:
																'pre-wrap',
														}
													: { whiteSpace: 'pre-wrap' }
											"
											:textToHighlight="note.information"
										>
										</Highlighter>
									</div>
								</div>
							</template>
							<template
								v-if="
									note.headline_id &&
									note.headline_type === 'plan'
								"
							>
								<template v-if="readMore && !data.plan">
									<img
										style="top: calc(50% - 38px)"
										class="loader"
										src="/safejournal/app-assets/images/common/loader.gif"
									/>
								</template>
								<template v-else-if="readMore && data.plan">
									<div class="row flex-column">
										<plan-data
											:plan="data.plan"
											:journal-answers="note.answers"
											is-view
										></plan-data>
									</div>
								</template>
							</template>
							<template v-if="note.data_registration_id">
								<template
									v-if="readMore && !data.dataregistration"
								>
									<img
										style="top: calc(50% - 38px)"
										class="loader"
										src="/safejournal/app-assets/images/common/loader.gif"
									/>
								</template>
								<template
									v-else-if="
										readMore && data.dataregistration
									"
								>
									<div style="margin-top: 10px">
										<template-helper-input
											:isEdit="false"
											:isPreview="false"
											:isDateChange="false"
											:isRegister="false"
											:template="data.dataregistration"
											:templateHistory="
												note.template_answers
											"
										>
										</template-helper-input>
									</div>
								</template>
							</template>
						</div>
						<div
							style="
								display: flex;
								justify-content: space-between;
							"
						>
							<a
								@click="$emit('readMore', note.journal_id)"
								v-if="!readMore && isReadMore && !isExport"
								class="note-read-more"
								style="align-content: flex-end"
								>Læs mere</a
							>
							<template
								v-if="
									(!readMore &&
										note.headline_id &&
										note.headline_type === 'plan') ||
									(!readMore && note.data_registration_id)
								"
							>
								<div class="d-flex gap-1" style="gap: 1rem">
									<template
										v-if="note.headline_type === 'plan'"
									>
										<i
											class="la la-newspaper-o"
											style="
												color: var(--clr-green);
												font-size: 2.5rem;
												width: 2.25rem;
												height: 2.25rem;
											"
										></i>
									</template>
									<template v-if="note.data_registration_id">
										<font-awesome-icon
											icon="fa-light fa-chart-line-up-down"
											width="2rem"
											color="var(--clr-green)"
											class="d-flex align-self-end"
										/>
									</template>
								</div>
							</template>
						</div>
					</div>
					<div class="row separator" />
					<div class="note-footer">
						<div class="note-info">
							<div>
								<div style="font-size: 0.8em">
									<div
										v-if="
											note.add_user_name && note.add_date
										"
									>
										<template v-if="note.add_user_name">
											<span
												style="
													display: inline-block;
													width: 6rem;
												"
											>
												Oprettet af:
											</span>
											<span>
												{{ note.add_user_name }}
											</span>
										</template>
										<template v-if="note.add_date">
											<span>
												den
												{{
													format(
														new Date(
															note.add_date *
																1000,
														),
														"d. MMMM yyyy, 'kl.' HH.mm",
													)
												}}
											</span>
										</template>
									</div>
									<div
										v-if="
											note.update_user_name &&
											note.last_updated
										"
									>
										<template v-if="note.update_user_name">
											<span
												style="
													display: inline-block;
													width: 6rem;
												"
											>
												Redigeret af:
											</span>
											<span>
												{{ note.update_user_name }}
											</span>
										</template>
										<template v-if="note.last_updated">
											<span>
												den
												{{
													format(
														new Date(
															note.last_updated,
														),
														"d. MMMM yyyy, 'kl.' HH.mm",
													)
												}}
											</span>
										</template>
									</div>
									<div>
										<template
											v-if="
												note.joural_date &&
												!isSameDay(
													new Date(
														note.add_date * 1000,
													),
													new Date(note.joural_date),
												)
											"
										>
											<span
												style="
													display: inline-block;
													width: 6rem;
												"
											>
												Gældende for:
											</span>
											<span>
												{{
													format(
														new Date(
															note.joural_date,
														),
														"d. MMMM yyyy, 'kl.' HH.mm",
													)
												}}
											</span>
										</template>
									</div>
								</div>
							</div>
							<div
								v-if="note.type"
								class="theme-row"
								style="
									display: flex;
									gap: 0.5rem;
									flex-direction: row;
									justify-content: flex-end;
									flex-wrap: wrap;
									flex: 1 1 50%;
								"
							>
								<template v-if="note.type?.id === 3">
									<font-awesome-icon
										icon="fa-solid fa-lock"
										width="1.5rem"
										color="var(--clr-purple)"
										class="d-flex align-self-start"
									></font-awesome-icon>
								</template>
								<template
									v-if="
										note.themes?.some(
											(theme) =>
												theme?.journal_type_id ===
													note.type?.id ||
												note.type?.id === 3,
										)
									"
								>
									<div
										v-for="theme in note?.themes"
										:key="theme.id"
										class="note-label"
										:style="{
											background: note.type?.color,
										}"
									>
										{{ theme.name }}
									</div>
								</template>
								<template v-else>
									<label
										v-if="note.type?.default"
										class="note-label"
										:style="{
											background: note.type?.color,
										}"
									>
										{{
											note.type?.id === 1
												? "Pædagogisk "
												: note.type?.id === 2
													? "Sundhedsfagligt "
													: note.type?.id === 3
														? "Fortroligt "
														: ""
										}}
									</label>
									<label
										v-else
										class="note-label"
										:style="{
											background: note.type?.color,
										}"
										>{{ note.type?.name }}</label
									>
								</template>
							</div>
						</div>
						<template v-if="note?.comments?.length > 0">
							<div
								class="comment-section"
								style="padding-top: 0.5rem"
							>
								<div
									class="card default-collapse m-0"
									v-if="!isExport"
								>
									<a class="card-header collapsed p-0">
										<div
											@click="isExpanded = !isExpanded"
											class="card-title"
										>
											<div>
												<font-awesome-icon
													:icon="
														isExpanded
															? 'arrow-up'
															: 'arrow-down'
													"
													color="#3a73b8"
													width="0.7rem"
													style="
														vertical-align: baseline;
													"
												/>
												<span class="moretitle">
													&nbsp;Kommentarer ({{
														note.comments?.length
													}})</span
												>
											</div>
										</div>
									</a>
								</div>
								<Collapse
									:when="isExpanded"
									class="v-collapse"
									v-if="!isExport"
								>
									<div
										v-for="comment in note?.comments"
										class="col p-1"
										:key="comment?.comment_id"
									>
										<span style="font-style: italic"
											>{{ comment.comment }}
										</span>
										<div style="font-size: 12px">
											<div style="padding-top: 0.5rem">
												<span
													style="
														display: inline-block;
														width: 6rem;
													"
													>Oprettet af:</span
												>
												<span class="cardinfo"
													>{{
														getCommentUserName(
															comment,
														)
													}}
													{{
														dateMonthYearTime(
															comment.add_date,
														)
													}}
												</span>
											</div>
										</div>
									</div>
								</Collapse>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
	</template>
</template>
<script setup>
import { dateMonthYearTime } from "@helpers/dateHelper";
import permissionModule from "@helpers/PermissionHelper";
import { studentURL } from "@helpers/studentHelper";
import TemplateHelperInput from "@helpers/templates/templateHelperInput.vue";
import TemplateService from "@services/TemplateService";
import { format, isSameDay } from "date-fns";
import Swal from "sweetalert2";
import { computed, onBeforeMount, onMounted, ref } from "vue";
import { Collapse } from "vue-collapsed";
import Highlighter from "vue-highlight-words";
import vTooltip from "../../directives/tooltip";
import JournalService from "../../services/JournalService.js";
import PlanData from "../plan/planData.vue";

const service = new JournalService();

const props = defineProps({
	note: Object,
	readMore: Boolean,
	isNormalView: Boolean,
	isExport: Boolean,
	terms: Object,
	searchText: String,
	currentUser: Object,
	store: Object,
});

const data = ref({
	dataregistration: null,
	plan: null,
});

const isExpanded = ref(false);

const keywords = computed(() => props.searchText?.split(" ") || []);

const exportSingle = async (id) => {
	try {
		const response = await service.exportSingle(id);

		const contentDisposition = response.headers["content-disposition"];
		const match = contentDisposition.match(/filename="(.+)"/);
		const fileName = match ? match[1] : "journal.pdf";

		const blob = new Blob([response.data], { type: "application/pdf" });
		const blobUrl = URL.createObjectURL(blob);

		const link = document.createElement("a");
		link.href = blobUrl;
		link.download = fileName;
		link.click();

		setTimeout(() => {
			URL.revokeObjectURL(blobUrl);
		}, 100);
	} catch (error) {
		console.log(error);
	}
};

const isReadMore = ref(false);

const noteBodyRefs = ref([]);

const isTextClamped = (elm) => elm?.scrollHeight > elm?.clientHeight;

const observeNoteClamp = () => {
	const noteBodys = noteBodyRefs?.value;
	if (!noteBodys) return;

	const clampObserver = new ResizeObserver((e) => {
		const { target } = e[0];
		if (
			isTextClamped(target) ||
			isTextClamped(target?.querySelector(".note-information")) ||
			isTextClamped(target?.querySelector(".category-answer")) ||
			props.note?.data_registration_id ||
			props.note?.headline_type === "plan"
		) {
			isReadMore.value = true;
		} else {
			isReadMore.value = false;
		}
	});
	clampObserver.observe(noteBodys);
};

const deleteNote = async (id) => {
	new Swal({
		// the custom HTML is to switch the default order of the title and text properties
		// it is not ideal as the font looks slightly different
		// Fixed - Niklas
		title: `Du er i gang med at slette et ${props.terms.note.single}`,
		text: "Er du sikker?",
		icon: "error",
		showCancelButton: true,
		reverseButtons: true,
		cancelButtonText: "Annuller",
		confirmButtonText: "Slet",
		customClass: {
			confirmButton: "btn-deletion",
			cancelButton: "btn-bluedesign",
		},
	}).then(async (result) => {
		if (result.isConfirmed) {
			await service.delete(id).then(() => {
				Swal.fire({
					title: "",
					icon: "success",
					text: `${props.terms.note.single_cap}et er slettet`,
					timer: 2000,
					showConfirmButton: false,
				});
				setTimeout(() => {
					emit("close", parseInt(id));
				}, 1500);
			});
		}
	});
};

const fetchTemplate = async () => {
	if (props.readMore && props.note.data_registration_id) {
		try {
			const templateService = new TemplateService();
			data.value.dataregistration = await templateService.getTemplate(
				props.note.data_registration_id,
			);
		} catch (error) {
			console.log(error);
			console.log(error.response?.data?.errors);
			console.log(error.response?.data?.message);
		}
	}
};

const fetchPlan = async () => {
	if (
		props.readMore &&
		props.note.headline_id &&
		props.note.headline_type === "plan"
	) {
		try {
			data.value.plan = await service
				.journalPlan(props.note.headline_id)
				.then((response) => response.data);
		} catch (error) {
			console.log(error);
			console.log(error.response?.data?.errors);
			console.log(error.response?.data?.message);
		}
	}
};

const getCommentUserName = (comment) => {
	if (!comment.user) {
		return `${props.currentUser.fname} ${props.currentUser.lname}`;
	}
	return `${comment.user.fname} ${comment.user.lname}`;
};

onBeforeMount(async () => {
	await fetchTemplate();
	await fetchPlan();
});

onMounted(() => {
	observeNoteClamp();
});
const emit = defineEmits(["close", "readMore"]);
</script>
